module.exports = __webpack_public_path__ + "media/styles/images/png/circle-right-arrow-gray-dark-on-white-ba3c708d750ac0ebbb493538335f7871.png";